import React from "react";

function TrafficHomeOne({ className }) {
  return (
    <section className={`appie-service-area pt-140 pb-180 ${className || ""}`}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="appie-traffic-title">
              <h3 className="title">Volleyball Rules and Regulations</h3>
              <ul>
                <li>
                  a. Common rules
                  <ul>
                    <li>• 2 Points per win</li>
                    <li>• 1 Point each for a tied match</li>
                  </ul>
                </li>
              </ul>
              <h3>Playing Conditions</h3>
              <ul>
                <li>• Six players and two rolling substitutions per side.</li>

                <li>
                  • Once the substitution is completed, then that player cannot
                  be subbed again (Final decision will be taken by the
                  officials)
                </li>
                <li>
                  • Mixed teams, comprising both male and female players, are
                  allowed.
                </li>
                <li>
                  • League Matches would be of best of 3 Sets. The first two
                  Sets 25 Points & the decider set will be of 15 points
                </li>
                <li>
                  • The knockout matches will be of 5 sets. The first four sets
                  would be of 25 Points & the decider set would be of 15 Points.
                </li>
                <li>
                  • a team can score Points while serving as well as while
                  taking the serve
                </li>
                <li>• Team that wins the point serves the next point</li>
                <li>
                  • In case of Deuce team winning two straight points wins the
                  set
                </li>
                <li>
                  • After each change the only service will be rotated, not the
                  players
                </li>
                <li>• All other FIVB Rules would be applicable</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TrafficHomeOne;
